<div class="sidebar-area bg-white transition" [ngClass]="{'active': isToggled}">
  <div class="logo bg-white">
    <a [routerLink]="logoRoute" class="d-flex align-items-center">
      <img src="assets/images/logos/isotipo_opb.png" alt="OPB Isotipo" class="opb-isotipo">
      <div class="opb-logo-text">
        <img src="assets/images/logos/logo_letras_opb.png" alt="OPB Logo Text" class="opb-logo-text-image">
      </div>
    </a>
  </div>
  <button type="button" 
          class="burger-menu transition cursor-pointer" 
          [ngClass]="{'active': isToggled}" 
          (click)="toggle()" 
          [attr.aria-label]="isToggled ? 'Cerrar menú' : 'Abrir menú'"
          [attr.aria-expanded]="isToggled">
    <span class="top-bar transition bg-dark d-block"></span>
    <span class="middle-bar transition bg-dark d-block"></span>
    <span class="bottom-bar transition bg-dark d-block"></span>
  </button>
  <ng-scrollbar visibility="hover">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <mat-accordion>
          <a *ngIf="canViewInicio()" routerLink="/home" class="sidebar-menu-link" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}">
            <i-feather name="home"></i-feather>
            <span class="title">
              Inicio
            </span>
          </a>

          <!-- Módulos sin grupo (se muestran después de Inicio) -->
          <ng-container *ngFor="let module of modulesWithoutGroup">
            <a [routerLink]="module.route || '/home'"
               class="sidebar-menu-link"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}">
              <i-feather *ngIf="!(module.icon || '').startsWith('mat:')" [name]="module.icon || 'circle'"></i-feather>
              <span *ngIf="(module.icon || '').startsWith('mat:')" class="material-symbols-outlined">{{ (module.icon || '').slice(4) }}</span>
              <span class="title">
                {{ module.name }}
              </span>
            </a>
          </ng-container>

          <!-- Módulos Dinámicos agrupados por menuGroup -->
          <ng-container *ngFor="let groupData of menuGroupsList">
            <span class="sub-title text-body" *ngIf="groupData.group !== 'SIN GRUPO'">
              {{ groupData.group }}
            </span>
            <a *ngFor="let module of groupData.modules" 
               [routerLink]="module.route || '/home'" 
               class="sidebar-menu-link" 
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}">
              <i-feather *ngIf="!(module.icon || '').startsWith('mat:')" [name]="module.icon || 'circle'"></i-feather>
              <span *ngIf="(module.icon || '').startsWith('mat:')" class="material-symbols-outlined">{{ (module.icon || '').slice(4) }}</span>
              <span class="title">
                {{ module.name }}
              </span>
            </a>
          </ng-container>

          
           <ng-container *ngIf="canViewAdministrationBlock()">
             <span class="sub-title text-body">
               ADMINISTRACIÓN
             </span>

             <a *ngIf="canViewUsers()" routerLink="/users" class="sidebar-menu-link" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}">
               <i-feather name="users"></i-feather>
               <span class="title">
                 Usuarios
               </span>
             </a>
             <a *ngIf="canViewUsers()" routerLink="/modules" class="sidebar-menu-link" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}">
               <i-feather name="layers"></i-feather>
               <span class="title">
                 Módulos
               </span>
             </a>
             <a *ngIf="canViewUsers()" routerLink="/parameters" class="sidebar-menu-link" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}">
               <i-feather name="settings"></i-feather>
               <span class="title">
                 Parámetros
               </span>
             </a>
             <a *ngIf="canViewUsers()" routerLink="/mantenedor-ayudas" class="sidebar-menu-link" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: false}">
               <i-feather name="file-text"></i-feather>
               <span class="title">
                 Mantenedor de Ayudas
               </span>
             </a>
           </ng-container>

          <a *ngIf="canViewUsers()" routerLink="/docs" class="sidebar-menu-link" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }">
            <i-feather name="book-open"></i-feather>
            <span class="title">Documentación</span>
          </a>

          <a routerLink="/authentication/logout" class="sidebar-menu-link" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}">
            <i-feather name="log-out"></i-feather>
            <span class="title">Salir</span>
          </a>
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>